import { useTooltip } from '../../components/Tooltip/useTooltip';
import { useStores } from '../../stores/useStores';

import type { CoinBackSteps } from './constants';

type TooltipParams = Parameters<typeof useTooltip>;

export function useCoinBackTutorial(step: CoinBackSteps, placement: TooltipParams[0], offset: TooltipParams[1]) {
  const { coinBackStore, featureManagerStore } = useStores();
  const isStepActive =
    coinBackStore.isTutorialOpen &&
    coinBackStore.tutorialStep === step &&
    (!featureManagerStore.currentFeatureType || featureManagerStore.currentFeatureType === 'CoinBack');

  const { tooltipStyles, setReferenceElement, setPopperElement } = useTooltip(placement, offset);

  return {
    showCoinBackTutorial: isStepActive,
    tooltipStyles,
    setReferenceElement,
    setPopperElement,
  };
}
